export function checkForUnauthorisedResponse(error, agent) {
  if(error && (error.status === 401 || error.status === 403)) {
    window.localStorage.setItem('jwt', '');
    window.localStorage.setItem('configurationId', '');
    agent.setToken(null);
    window.location.replace("#/login")
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/Utils/ErrorHandler.js